import { render, staticRenderFns } from "./ReplicantiGalaxyButton.vue?vue&type=template&id=071368e8&scoped=true"
import script from "./ReplicantiGalaxyButton.vue?vue&type=script&lang=js"
export * from "./ReplicantiGalaxyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071368e8",
  null
  
)

export default component.exports